import { Indicator } from '../../../../interfaces/IndicatorIndex'
import { useAppSelector } from '../../../../redux/hooks'
import { INDICATOR_TYPE_STRUCTURAL } from '../../../../utils/const'

const List = ({ indicator, letter }: { indicator: Indicator, letter: string }) => {
    const { lastPeriod } = useAppSelector((state) => state.periods);
    const href = `/monitor/visualizador-de-indicadores?right=${indicator.derecho.titulo}&rightId=${indicator.derecho.id}&period=${indicator.tipo_indicador !== INDICATOR_TYPE_STRUCTURAL ? lastPeriod?.value : indicator.sancion}&indicatorID=${indicator.id}&type=${indicator.tipo_indicador}&dimensionID=${indicator.dimension.id}&subdimensionID=${indicator.subdimension.id}&filterApplied='true'`;

    const handleClick = () => {
        const previousData = {
            path: "/indice-indicadores",
            letter: `${letter}`,
            label: 'Volver a Indice de Indicadores',
            scrollTargetId: 'indicators-index',
        };

        sessionStorage.setItem("previous", JSON.stringify(previousData));
    };

    return (
        <a
            href={href}
            className='group py-2 px-4 block'
            onClick={handleClick}
        >
            <p className="text-blarge text-system-light-100 underline decoration-transparent group-hover:text-primary-40 group-hover:decoration-primary-40 transition-colors duration-200">
                {indicator.titulo}
            </p>
            <p className="text-bsmall text-system-light-50">{indicator.breadcrumbs}</p>
        </a >
    )
}

export default List